import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postCsvUsers = async ({ rootGetters }, { clientSid, userInfo }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.postHubCsvUsers(clientSid, userInfo);
  return response;
};
